import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-indicadores_cia',
  templateUrl: './indicadores_cia.component.html',
  styleUrls: ['./indicadores_cia.component.css']
})
export class Indicadores_ciaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
